import React from 'react';
export function StudentTableSkeleton({
  rows = 6
}: {
  rows?: number;
}) {
  return <div className="p-4" aria-busy="true" aria-live="polite" data-id="element-415" data-mp="el63b3nqy12v">
      <span className="sr-only" data-id="element-416" data-mp="emqtkh312xux">Loading student records from Firestore…</span>
      <div className="hidden md:block" data-id="element-417" data-mp="my6cvqpmzrp">
        <div className="mb-3 flex items-center gap-4 px-2" data-id="element-418" data-mp="5kq07vax0vyj">
          {[12, 28, 12, 14, 20, 14].map((width, index) => <div key={index} className="shimmer h-3 rounded-full" style={{
          width: `${width}%`
        }} data-id="element-419" data-mp="t9sgozttcirg" data-mpi={index} />)}
        </div>
        {Array.from({
        length: rows
      }).map((_, rowIndex) => <div key={rowIndex} className="flex items-center gap-4 border-t border-[var(--glass-hairline)] px-2 py-4" style={{
        opacity: 1 - rowIndex * 0.08
      }} data-id="element-420" data-mp="jksdt5c6x37z" data-mpi={rowIndex}>
            <div className="shimmer h-10 w-10 shrink-0 rounded-xl" data-id="element-421" data-mp="1c9g1t8obq6p8" />
            <div className="flex-1 space-y-2" data-id="element-422" data-mp="1c73h4nr6li8h">
              <div className="shimmer h-3 w-1/3 rounded-full" data-id="element-423" data-mp="1h06d12jfl3ru" />
              <div className="shimmer h-2.5 w-1/4 rounded-full" data-id="element-424" data-mp="fny6d08gn7xy" />
            </div>
            <div className="shimmer h-3 w-16 rounded-full" data-id="element-425" data-mp="flu6ctdomt2y" />
            <div className="shimmer h-3 w-24 rounded-full" data-id="element-426" data-mp="apwr6qe5nsrr" />
            <div className="shimmer h-3 w-32 rounded-full" data-id="element-427" data-mp="og042qr5aa4j" />
            <div className="shimmer h-8 w-8 rounded-lg" data-id="element-428" data-mp="ohjkchcswl6b" />
          </div>)}
      </div>

      <div className="space-y-3 md:hidden" data-id="element-429" data-mp="jnysz85pqpg3">
        {Array.from({
        length: 4
      }).map((_, index) => <div key={index} className="rounded-2xl border border-[var(--glass-hairline)] p-4" data-id="element-430" data-mp="ycla9fewhr9y" data-mpi={index}>
            <div className="flex items-center gap-3" data-id="element-431" data-mp="tetluvdgsnai">
              <div className="shimmer h-12 w-12 rounded-xl" data-id="element-432" data-mp="17fmefak7h8az" />
              <div className="flex-1 space-y-2" data-id="element-433" data-mp="17d06h9tekqs8">
                <div className="shimmer h-3 w-2/3 rounded-full" data-id="element-434" data-mp="13d97wjxmx6d5" />
                <div className="shimmer h-2.5 w-1/3 rounded-full" data-id="element-435" data-mp="396hfagt9rxok" />
              </div>
            </div>
            <div className="mt-4 space-y-2" data-id="element-436" data-mp="3555kzxzgaoa1">
              <div className="shimmer h-2.5 w-full rounded-full" data-id="element-437" data-mp="35676kwe3et60" />
              <div className="shimmer h-2.5 w-4/5 rounded-full" data-id="element-438" data-mp="184rlav3fqlmx" />
            </div>
          </div>)}
      </div>
    </div>;
}